import { FC } from 'react';
import { Box } from '@chakra-ui/react';

interface PdfPreviewProps {
  fileSrc: string;
}

const PdfPreview: FC<PdfPreviewProps> = ({ fileSrc }) => (
  <Box height="100%" width="100%">
    <embed height="100%" src={fileSrc} width="100%" />
  </Box>
);

export default PdfPreview;
